<div class="tem-field content-container">
    <label class="tem-field-label">{{label}}</label>
    <nz-input-group [nzSuffix]="clearTpl">
        <input nz-input type="text" [formControl]="fillControl" [placeholder]="label">
    </nz-input-group>
    <ng-template #clearTpl>
        <nz-icon *ngIf="fillControl.value" nzType="close-circle" class="clear-icon" (click)="fillControl.setValue('')"></nz-icon>
    </ng-template>
    <div class="field-error" *ngIf="fillControl.touched && fillControl.hasError('required')">
        {{message}}
    </div>
</div>
<div class="options">
    <button nz-button nzDanger id="no-button" (click)="closeDialog()">Cancelar</button>
    <button nz-button nzType="primary" id="yes-button" (click)="salvar()">Salvar</button>
</div>
